define('responsive-gameday/controllers/PitchByPitchViewController',['require','exports','module','Responsive/controllers/ScrollViewController','../views/render/PitchByPitchViewRender','Responsive/util/renderComplete','../views/Monitor/Events/ViewModelUpdateEvents','message-service/message-service'],function(require,exports,module) {
    // Add private variables here
    var ScrollViewController = require("Responsive/controllers/ScrollViewController"),
        PitchByPitchViewRender = require( '../views/render/PitchByPitchViewRender' ),
        renderComplete = require("Responsive/util/renderComplete"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service");

    var renderers = null,
        Superclass;
    
    function onBeat(payload, evt) {
        var parent = this.childWrapper,
            self = this;

        if (!payload || !this.isViewLoaded()) {
            return;
        }

        if(this.pitchToggler){
            this.viewRender.viewState.pitches_visible = this.pitchToggler.pitchesState;
        }

        parent.innerHTML = this.viewRender.render(payload);

        this.hideOverlay();
        renderComplete(function () {
            if (self.isViewLoaded()) {
                self.setScroll();
            }
        });
    };


    // Constructor
    function PitchByPitchViewController(type) {
        // Call super constructor
        Superclass.constructor.call(this);
        this.referenceName = "pitchbypitch";
        this.viewRender = new PitchByPitchViewRender();

        this.onBeat = function(payload,evt){
            onBeat.call(this,payload,evt);
        };

        MessageService.publish("registerViewComponent", this);
    }

    // Prototype Inheritence
    ScrollViewController.spawn(PitchByPitchViewController).define({

        loadView: function () {
            Superclass.loadView.call(this);
            this.setClassName("PitchByPitchViewController");
        },

        viewWillAppear: function () {
            this.showOverlay();

            Superclass.viewWillAppear.call(this);
            this.viewRender.setPitchToggler(this);
        },

        viewDidAppear : function(){
            Superclass.viewDidAppear.call(this);
            MessageService.addListener.call(this, VMEvents.UPDATE_PITCHBYPITCH, this.onBeat);
            MessageService.publish(VMEvents.REQUEST_PITCHBYPITCH_DATA);
        },

        viewWillDisappear: function () {
            Superclass.viewWillDisappear.call(this);
            MessageService.removeListener(VMEvents.UPDATE_PITCHBYPITCH, this.onBeat);
        }

    });

    Superclass = PitchByPitchViewController.superclass;
    return PitchByPitchViewController;
});
